// src/components/ModalAvisoPrivacidadObligatorio.js
import React, { useState } from 'react';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { useAuth } from '../context/AuthContext';
import { FaShieldAlt, FaExternalLinkAlt, FaCheck, FaLock } from 'react-icons/fa';
import './ModalAvisoPrivacidadObligatorio.css';

const ModalAvisoPrivacidadObligatorio = () => {
    const { currentUser, userData, updateLocalUserData } = useAuth();
    const [acceptedCheck, setAcceptedCheck] = useState(false);
    const [saving, setSaving] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');

    // Si no hay usuario o ya aceptó el aviso de privacidad, no se renderiza
    if (!currentUser || !userData || userData.privacyPolicyAccepted === true) {
        return null;
    }

    const handleConfirm = async () => {
        if (!acceptedCheck) {
            setErrorMsg('Debes marcar la casilla para confirmar que has leído y aceptas el Aviso de Privacidad.');
            return;
        }

        setSaving(true);
        setErrorMsg('');

        const acceptedDateIso = new Date().toISOString();
        const updatePayload = {
            privacyPolicyAccepted: true,
            privacyPolicyAcceptedDate: acceptedDateIso,
        };

        // 1. Actualización reactiva inmediata en memoria local
        if (updateLocalUserData) {
            updateLocalUserData(updatePayload);
        }

        // 2. Persistencia en Firestore
        try {
            const userRef = doc(db, 'usuarios', currentUser.uid);
            await updateDoc(userRef, updatePayload);
        } catch (error) {
            console.error('Error al guardar la aceptación del aviso de privacidad en Firestore:', error);
            // No bloqueamos al usuario si ya se actualizó en memoria local
        } finally {
            setSaving(false);
        }
    };

    const handleOpenFullNotice = (e) => {
        e.preventDefault();
        window.open('/aviso-privacidad', '_blank', 'noopener,noreferrer');
    };

    return (
        <div className="aviso-privacidad-modal-backdrop" role="dialog" aria-modal="true">
            <div className="aviso-privacidad-modal-card">
                <div className="aviso-privacidad-modal-header">
                    <div className="aviso-privacidad-icon-badge">
                        <FaShieldAlt />
                    </div>
                    <div className="aviso-privacidad-header-text">
                        <h2>Aviso de Privacidad</h2>
                        <p>Protección y resguardo de tus datos personales</p>
                    </div>
                </div>

                <div className="aviso-privacidad-modal-body">
                    <div className="aviso-privacidad-alert-box">
                        <FaLock className="aviso-lock-icon" />
                        <div>
                            <strong>Información importante:</strong>
                            <p>
                                Para garantizar la transparencia y seguridad en el uso de la plataforma condominal, 
                                es necesario confirmar la lectura y conformidad con nuestro Aviso de Privacidad.
                            </p>
                        </div>
                    </div>

                    <div className="aviso-privacidad-summary-text">
                        <p>
                            Los datos personales recabados (como nombre, teléfono, domicilio y registros de acceso o pagos) 
                            son tratados exclusivamente para fines de administración interna, seguridad del fraccionamiento, 
                            emisión de comprobantes y comunicación oficial entre residentes y el comité de administración.
                        </p>
                    </div>

                    <div className="aviso-privacidad-link-wrapper">
                        <button 
                            type="button" 
                            className="aviso-privacidad-link-btn" 
                            onClick={handleOpenFullNotice}
                        >
                            <span>Leer Aviso de Privacidad Completo</span>
                            <FaExternalLinkAlt className="external-icon" />
                        </button>
                    </div>

                    {errorMsg && (
                        <div className="aviso-privacidad-error-box">
                            {errorMsg}
                        </div>
                    )}

                    <label className="aviso-privacidad-checkbox-container">
                        <input
                            type="checkbox"
                            checked={acceptedCheck}
                            onChange={(e) => {
                                setAcceptedCheck(e.target.checked);
                                if (e.target.checked) setErrorMsg('');
                            }}
                            disabled={saving}
                        />
                        <span className="aviso-privacidad-checkmark">
                            {acceptedCheck && <FaCheck className="check-svg" />}
                        </span>
                        <span className="aviso-privacidad-checkbox-label">
                            He leído y acepto los términos y condiciones del <strong>Aviso de Privacidad</strong>.
                        </span>
                    </label>
                </div>

                <div className="aviso-privacidad-modal-footer">
                    <button
                        type="button"
                        className={`aviso-privacidad-submit-btn ${!acceptedCheck || saving ? 'disabled' : ''}`}
                        onClick={handleConfirm}
                        disabled={!acceptedCheck || saving}
                    >
                        {saving ? 'Guardando aceptación...' : 'Aceptar y Continuar'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ModalAvisoPrivacidadObligatorio;
